import { siteApiSlice } from "../../../../app/siteApiSlice";
import { ScoresFilteredByCourseViewModel } from "./ScoresFilteredByCourseViewModel";

export const coursePerformanceReportApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		coursePerformanceReport: build.query<
			ScoresFilteredByCourseViewModel,
			{ writerId?: number; courseId?: number }
		>({
			query: (arg) => {
				const { writerId, courseId } = arg;
				return {
					url: `/performance-report`,
					params: { writerId, courseId },
				};
			},
			providesTags: ["CurrentCourse"],
		}),
	}),
});

export const { useCoursePerformanceReportQuery } = coursePerformanceReportApiSlice;
